import { useMemo } from "react";
import { useFormContext } from "../contexts/FormContext";
import { conceptCodes, conceptIDs } from "../../constants/constant";

interface UseErrorClassClassifier {
  error?: boolean;
  errorClassToApply?: string;
  defaultClass?: string;
}

const enabledConcepts = [
  conceptIDs?.MRA_CONCEPT_ID,
  conceptCodes?.MRA_CONCEPT_CODE,
];
const enableAllBrands = true;

export const useErrorClassClassifier = ({
  error = false,
  errorClassToApply = "",
  defaultClass = "",
}: UseErrorClassClassifier): string => {
  const { formValues } = useFormContext();
  const conceptCode = sessionStorage.getItem("conceptCode");
  const isEnabledForConcept =
    enableAllBrands ||
    enabledConcepts.includes(formValues.conceptID) ||
    enabledConcepts.includes(conceptCode);
  const styles = useMemo(() => {
    const errorClassToApplyMemo = `${errorClassToApply}`;
    const defaultClassMemo = `${defaultClass}`;
    if (!isEnabledForConcept) {
      return defaultClass;
    }
    return error ? errorClassToApplyMemo : defaultClassMemo;
  }, [error, errorClassToApply]);

  return styles;
};
